import _implicitStylesheets from "./button.css";
import _implicitScopedStylesheets from "./button.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _axButton from "ax/button";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: {
      "type": $cmp.elementType
    },
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics)),
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClick))
    }
  }, [api_custom_element("ax-button", _axButton, {
    attrs: {
      "data-id": $cmp.id
    },
    props: {
      "variant": $cmp.variant,
      "disabled": $cmp.disabled,
      "text": $cmp.displayText,
      "type": $cmp.type,
      "size": $cmp.size,
      "ariaLabel": $cmp.ariaLabel,
      "ariaLive": $cmp.ariaLive,
      "ariaExpanded": $cmp.ariaExpanded,
      "controlsId": $cmp.ariaControls,
      "form": $cmp.form,
      "theme": $cmp.theme,
      "width": $cmp.width,
      "href": $cmp.href,
      "target": $cmp.target
    },
    key: 1
  }, [$cmp.renderIcon ? api_custom_element("ax-icon", _axIcon, {
    slotAssignment: $cmp.iconPlacement,
    props: {
      "icon": $cmp.icon,
      "size": "large",
      "spriteUrl": $cmp.iconSpriteUrl,
      "ariaHidden": "true"
    },
    key: 2
  }) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-nfvqqei982";
tmpl.legacyStylesheetToken = "undefined-_button";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
